import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=66a486d0&scoped=true"
import script from "./Widget.vue?vue&type=script&lang=js"
export * from "./Widget.vue?vue&type=script&lang=js"
import style0 from "./Widget.vue?vue&type=style&index=0&id=66a486d0&prod&lang=scss"
import style1 from "./Widget.vue?vue&type=style&index=1&id=66a486d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a486d0",
  null
  
)

export default component.exports